import { Outlet, Route } from 'react-router-dom';
import OrganizationProfile from '../pages/Organization/public/Profile';
import NavbarDashboard from 'src/components/NavbarDashboard';

const OrganizationRoutes = (
  <>
    <Route
      path="o/:shortname/"
      element={
        <>
          <NavbarDashboard />
          <Outlet />
        </>
      }
    >
      <Route index element={<OrganizationProfile />} />
    </Route>
  </>
);

export default OrganizationRoutes;
